module.exports = __webpack_public_path__ + "img/dashboard-section-growth.c1818130.svg";